var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, transient } from "aurelia-dependency-injection";
import { RequestClient } from "../basics/request-client.service";
import { WorkflowConfigurationUrls } from "../../constants/workflow/workflow-configuration.constants";
import { toNative } from "../../utilities/promise-utils";
var WorkflowConfigurationService = /** @class */ (function () {
    function WorkflowConfigurationService(requestClient) {
        this.requestClient = requestClient;
    }
    WorkflowConfigurationService.prototype.getWorkflowConfigurations = function (entityTypeId, branchId) {
        return toNative(this.requestClient.get(WorkflowConfigurationUrls.getWorkflowConfigurations, { entityTypeId: entityTypeId, branchId: branchId }));
    };
    WorkflowConfigurationService.prototype.getActivityMetadata = function (entityTypeId, pluginInternalName) {
        return toNative(this.requestClient.get(WorkflowConfigurationUrls.getActivityMetadata, { entityTypeId: entityTypeId, pluginInternalName: pluginInternalName }));
    };
    WorkflowConfigurationService.prototype.getWorkflowConfiguration = function (workflowConfigurationId) {
        return toNative(this.requestClient.get(WorkflowConfigurationUrls.getWorkflowConfiguration, { id: workflowConfigurationId }));
    };
    WorkflowConfigurationService.prototype.saveWorkflowConfiguration = function (request) {
        return toNative(this.requestClient.post(WorkflowConfigurationUrls.saveWorkflowConfiguration, {}, request));
    };
    WorkflowConfigurationService.prototype.deleteWorkflowConfiguration = function (workflowConfigurationId) {
        return toNative(this.requestClient.post(WorkflowConfigurationUrls.deleteWorkflowConfiguration, {}, { workflowConfigurationId: workflowConfigurationId }));
    };
    WorkflowConfigurationService.prototype.accept = function (request) {
        return toNative(this.requestClient.post(WorkflowConfigurationUrls.accept, {}, request));
    };
    WorkflowConfigurationService.prototype.getEntityTypesForWorkflow = function () {
        return toNative(this.requestClient.get(WorkflowConfigurationUrls.getEntityTypesForWorkflow, {}));
    };
    WorkflowConfigurationService = __decorate([
        autoinject(),
        transient(),
        __metadata("design:paramtypes", [RequestClient])
    ], WorkflowConfigurationService);
    return WorkflowConfigurationService;
}());
export { WorkflowConfigurationService };
